import { chatttSDKChannel } from 'services/chattt/sdk';

export const channelList: ChannelLogin.ChannelCode[] = ['9caea11390faee419c9a32ae3d5bf830'];

export const isChannelLoginChannel = (channel: any): channel is ChannelLogin.ChannelCode => {
  return channelList.includes(channel);
};

export const configMap: Record<ChannelLogin.ChannelCode, ChannelLogin.Config> = {
  '9caea11390faee419c9a32ae3d5bf830': {
    name: 'SellerWell',
    code: '9caea11390faee419c9a32ae3d5bf830',
    forgotPasswordLink: 'https://user.sellerwell.com/forget-password',
    vaultName: 'SellerWell',
  },
};

export const getConfig = () => {
  if (!isChannelLoginChannel(chatttSDKChannel)) {
    return {
      name: '',
      code: '',
      forgotPasswordLink: '',
      vaultName: '',
    };
  }

  return configMap[chatttSDKChannel];
};
